(() => {
  if (window.__ynPdpTopFinalReady) return;
  window.__ynPdpTopFinalReady = true;

  const placeTopElements = (section) => {
    const header = section.querySelector('.product__section--header');
    const price = header?.querySelector('#product-price');
    if (!header || !price) return;

    const app = section.querySelector(
      '.product__section-details > .product__section--app, .product__section--header > .product__section--app'
    );
    const switcher = section.querySelector('[data-yn-model-switcher]');
    const facts = section.querySelector('.yn-signals-placement--desktop');

    let anchor = price;

    if (app) {
      price.insertAdjacentElement('afterend', app);
      app.classList.add('yn-price-history');
      anchor = app;
    }

    if (switcher) {
      anchor.insertAdjacentElement('afterend', switcher);
      switcher.dataset.ynPlaced = 'true';
      anchor = switcher;
    }

    if (facts) {
      anchor.insertAdjacentElement('afterend', facts);
    }

    section.classList.add('yn-pdp-top-final');
  };

  const initializeAssurance = (section) => {
    const root = section.querySelector('[data-yn-assurance]');
    if (!root || root.dataset.ynFinalReady === 'true') return;

    const status = root.querySelector('[data-yn-assurance-status]');
    const statusCopy = root.querySelector('[data-yn-assurance-copy]');
    const soldoutNext = root.querySelector('[data-yn-soldout-next]');
    const button = section.querySelector('[data-yn-primary-add]');
    if (!status || !statusCopy || !button) return;

    root.dataset.ynFinalReady = 'true';

    const sync = () => {
      if (status.dataset.preorder === 'true' || button.getAttribute('aria-busy') === 'true') return;
      const available = !button.disabled;
      statusCopy.textContent = available ? status.dataset.availableCopy : status.dataset.unavailableCopy;
      root.classList.toggle('yn-assurance--available', available);
      root.classList.toggle('yn-assurance--unavailable', !available);
      if (soldoutNext) soldoutNext.hidden = available;
    };

    new MutationObserver(sync).observe(button, {
      attributes: true,
      childList: true,
      attributeFilter: ['disabled', 'aria-busy']
    });
    sync();
  };

  const initializeSection = (section) => {
    if (!(section instanceof Element)) return;
    placeTopElements(section);
    initializeAssurance(section);
    requestAnimationFrame(() => placeTopElements(section));
    window.setTimeout(() => placeTopElements(section), 450);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-section-type="product__section"]').forEach(initializeSection);
    if (scope.matches?.('[data-section-type="product__section"]')) initializeSection(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
